import { Ability } from "ember-can";
import { service } from "@ember/service";
import { FeatureFlag } from "glesys-controlpanel/utils/feature-flags";

export default class UserAbility extends Ability {
  @service storage;
  @service featureFlags;

  get canAccessThemeSelector() {
    return this.storage.get("glesys:cloud-theme-selector")
      ? this.storage.get("glesys:cloud-theme-selector") !== "false"
      : this.model
          ?.hasMany("organizations")
          .value()
          ?.some((organization) => this.featureFlags.isEnabled(organization, FeatureFlag.CloudThemeSelector));
  }
}
